import firebase from 'firebase/app'
import 'firebase/functions'
import qilinPreview from './qilinPreviewData'

export const qilinPreviewEnabled = process.env.NODE_ENV === 'development' &&
  process.env.VUE_APP_QILIN_PREVIEW === '1'

// This service is imported by Home while main.ts is still evaluating. Resolve
// Functions only when a request is made so Firebase has already been initialized.
function qilinFunctions () {
  return firebase.app().functions('asia-east2')
}

function currentUserkey () {
  try {
    const user = JSON.parse(localStorage.getItem('userData') || '{}')
    return user.key || ''
  } catch (error) {
    return ''
  }
}

async function callQilin (name, payload = {}) {
  const userkey = currentUserkey()
  if (!userkey) throw new Error('ไม่พบข้อมูลผู้ใช้ กรุณาเข้าสู่ระบบอีกครั้ง')
  const callable = qilinFunctions().httpsCallable(name)
  const response = await callable(Object.assign({ userkey }, payload))
  return response.data
}

export function qilinErrorMessage (error) {
  const code = String(error && error.code ? error.code : '')
  const message = String(error && error.message ? error.message : '')
  if (/feature is not enabled/i.test(message)) return 'ระบบคู่หูยังไม่เปิดให้บัญชีนี้ใช้งาน'
  if (code.includes('already-exists')) return 'รับสิทธิ์นี้ไปแล้ว กรุณาลองใหม่พรุ่งนี้'
  if (code.includes('unauthenticated')) return 'กรุณาเข้าสู่ระบบอีกครั้ง'
  if (code.includes('permission-denied')) return 'ระบบคู่หูยังไม่เปิดให้บัญชีนี้ใช้งาน'
  if (code.includes('failed-precondition') && /coin/i.test(message)) return 'เหรียญไม่เพียงพอสำหรับเปลี่ยนชื่อ'
  if (code.includes('failed-precondition')) return 'ยังทำเงื่อนไขไม่ครบ กรุณาตรวจสอบอีกครั้ง'
  if (code.includes('unavailable')) return 'เชื่อมต่อไม่สำเร็จ กรุณาลองอีกครั้ง'
  return 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง'
}

export default {
  getHomeStatus: () => qilinPreviewEnabled ? qilinPreview.getHomeStatus() : callQilin('getQilinHomeStatus'),
  getPetStatus: () => qilinPreviewEnabled ? qilinPreview.getPetStatus() : callQilin('getQilinPetStatus'),
  play: () => qilinPreviewEnabled ? qilinPreview.play() : callQilin('playWithQilinPet'),
  updateProfile: payload => qilinPreviewEnabled ? qilinPreview.updateProfile(payload) : callQilin('updateQilinPetProfile', payload),
  getCheckinStatus: () => qilinPreviewEnabled ? qilinPreview.getCheckinStatus() : callQilin('getQilinCheckinStatus'),
  claimCheckin: () => qilinPreviewEnabled ? qilinPreview.claimCheckin() : callQilin('claimQilinDailyCheckin'),
  getMissionsStatus: () => qilinPreviewEnabled ? qilinPreview.getMissionsStatus() : callQilin('getQilinMissionsStatus'),
  claimMission: missionId => qilinPreviewEnabled ? qilinPreview.claimMission(missionId) : callQilin('claimQilinMissionReward', { missionId })
}
